var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAMarkLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 80,
    viewBox: "0 0 75.13 136.26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7FCFD",
    d: "M75.02,131.93L51.81,2.63c-.27-1.53-1.6-2.63-3.16-2.63h-22.07c-1.55,0-2.89,1.11-3.16,2.63L.14,132.31s-1.19,3.95,3.12,3.95h18.4c1.57,0,3.01-1.36,3.25-2.91l2.98-19.79c.09-.58.6-1.02,1.2-1.02h17.04c.6,0,1.11.43,1.2,1.02l2.98,19.79c.23,1.55,1.67,2.91,3.25,2.91h18.41c3.98,0,3.06-4.33,3.06-4.33ZM51.7,69.77l-5.72,5.3c-.33.3-.46.76-.34,1.18l2.6,9.48c.21.79-.12,1.62-.82,2.04-.7.42-1.6.33-2.21-.21l-6.55-5.91c-.47-.42-1.18-.42-1.64,0l-6.53,5.94c-.35.32-.8.48-1.25.48-.34,0-.67-.09-.98-.28-.7-.44-1.03-1.28-.79-2.06l2.79-9.36c.14-.46-.02-.95-.38-1.25l-6.26-5.25c-.59-.5-.8-1.3-.54-2.02.26-.72.96-1.2,1.73-1.2h7.55c.62,0,1.13-.46,1.2-1.07l2.2-18.91c.11-.91.9-1.6,1.83-1.61h.4c.93,0,1.7.69,1.81,1.6l2.26,18.9c.07.61.59,1.06,1.2,1.06h7.17c.82-.1,1.44.44,1.72,1.14.28.7.1,1.49-.45,2h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAMarkLight);
export default __webpack_public_path__ + "static/media/AMarkLight.5b512c0508814dce542241d06dcd2d0e.svg";
export { ForwardRef as ReactComponent };